<template>
  <div class="sort-method-wrapper">
    <div class="d-none d-lg-flex">
      <button
        class="filter-icon active-filter"
        @click="handleSortMethod({ field: 'name', direction: 'asc' }, $event)"
      >
        <span>{{ $t('letters.first') }}</span>
        <span class="sign">↑</span>
      </button>
      <button
        class="filter-icon mr-2"
        @click="handleSortMethod({ field: 'name', direction: 'desc' }, $event)"
      >
        <span>{{ $t('letters.last') }}</span>
        <span class="sign">↓</span>
      </button>
      <button
        class="filter-icon sort-like"
        @click="
          handleSortMethod({ field: 'rating', direction: 'desc' }, $event)
        "
      />
      <button
        class="filter-icon sort-dislike mr-2"
        @click="handleSortMethod({ field: 'rating', direction: 'asc' }, $event)"
      />
      <button
        class="filter-icon"
        @click="handleSortMethod({ field: 'price', direction: 'asc' }, $event)"
      >
        <span>{{ currency }}</span>
        <span class="sign">↑</span>
      </button>
      <button
        class="filter-icon"
        @click="handleSortMethod({ field: 'price', direction: 'desc' }, $event)"
      >
        <span>{{ currency }}</span>
        <span class="sign">↓</span>
      </button>
    </div>
    <div class="d-block d-lg-none">
      <el-select
        v-model="selectedSortMethod"
        :popper-append-to-body="false"
        placeholder="Choose"
        @change="handleMobileSortMethod(selectedSortMethod)"
      >
        <span slot="prefix">
          <i :class="prefixIcon"></i>
          {{ prefixSign }}
          <i :class="prefixArrow"></i>
        </span>
        <el-option
          v-for="method in allMethods"
          :key="method.key"
          :value="method"
        >
          <i :class="method.icon"></i>
          {{ method.sign }}
          <i :class="method.arrow"></i>
          {{ method.name }}
        </el-option>
      </el-select>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'SortMethods',
  data() {
    return {
      selectedSortMethod: null,
      prefixArrow: '',
      prefixIcon: '',
      prefixSign: ''
    }
  },
  computed: {
    ...mapGetters({
      currency: 'user/getCurrencySign',
      currentSortMethod: 'search/searchSort'
    }),
    allMethods() {
      return [
        {
          key: 2,
          icon: '',
          sign: `${this.$t('letters.first')}`,
          arrow: 'icon-Arrow_trener',
          name: `${this.$t('common.alphabetical')}`,
          method: { field: 'name', direction: 'asc' }
        },
        {
          key: 1,
          icon: '',
          sign: `${this.$t('letters.last')}`,
          arrow: 'icon-Arrow_trener_dis',
          name: `${this.$t('common.alphabetical')}`,
          method: { field: 'name', direction: 'desc' }
        },
        {
          key: 3,
          icon: 'icon-Like_trener',
          sign: '',
          arrow: '',
          name: `${this.$t('common.by_rating')}`,
          method: { field: 'rating', direction: 'desc' }
        },
        {
          key: 4,
          icon: 'icon-Like_trener_dis',
          sign: '',
          arrow: '',
          name: `${this.$t('common.by_rating')}`,
          method: { field: 'rating', direction: 'asc' }
        },
        {
          key: 6,
          icon: '',
          sign: `${this.currency}`,
          arrow: 'icon-Arrow_trener_dis',
          name: `${this.$t('common.by_price')}`,
          method: { field: 'price', direction: 'desc' }
        },
        {
          key: 5,
          icon: '',
          sign: `${this.currency}`,
          arrow: 'icon-Arrow_trener',
          name: `${this.$t('common.by_price')}`,
          method: { field: 'price', direction: 'asc' }
        }
      ]
    }
  },
  mounted() {
    this.selectedSortMethod = `${this.$t('common.alphabetical')}`
    this.setPrefix('', `${this.$t('letters.first')}`, 'icon-Arrow_trener')
  },
  methods: {
    ...mapActions({
      setSortMethod: 'search/SET_SORT_METHOD'
    }),
    handleSortMethod(obj, event) {
      this.setSortMethod(obj)
      this.$el.querySelector('.active-filter').classList.remove('active-filter')
      event.target.tagName === 'SPAN'
        ? event.target.parentNode.classList.add('active-filter')
        : event.target.classList.add('active-filter')
    },
    async handleMobileSortMethod(method) {
      await this.setSortMethod(method.method)

      this.setPrefix(method.icon, method.sign, method.arrow)
      this.selectedSortMethod = method.name

      this.$bus.$emit('clearList')
    },
    setPrefix(icon, sign, arrow) {
      this.prefixIcon = icon
      this.prefixSign = sign
      this.prefixArrow = arrow
    }
  }
}
</script>

<style scoped lang="scss">
@import '~assets/css/variables';

.active-filter {
  border: 1px solid $primary;
  color: $primary;
}
</style>
